/* eslint-disable @typescript-eslint/naming-convention */
import type { Highlight } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSPageSection, CMSReference } from '@swf/cms';

import sharedStyles from '../../styles/styles.scss';

import styles from './CMSHighlight.scss';

const CMSHighlight: React.FC<Highlight> = ({ heading, intro, body, item_alignment }) => (
  <CMSPageSection
    heading={heading}
    intro={intro}
    gridClassName={styles.highlight}
    className={sharedStyles[item_alignment || '']}
  >
    {body.length && body.map((item, index) => <CMSReference {...item} key={index} />)}
  </CMSPageSection>
);
export default CMSHighlight;
